import { render, staticRenderFns } from "./GoodsInterface.vue?vue&type=template&id=739111f9&scoped=true"
import script from "./GoodsInterface.vue?vue&type=script&lang=js"
export * from "./GoodsInterface.vue?vue&type=script&lang=js"
import style0 from "./GoodsInterface.vue?vue&type=style&index=0&id=739111f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739111f9",
  null
  
)

export default component.exports